<template>
  <div>
    <b-container fluid class="px-5">

      <div class="mt-4 d-flex align-items-start justify-content-between">
          <back-arrow :title="surgeryTemplate.name"/>
        <show-actions
          @clickOnEditBtn="clickOnEditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
        ></show-actions>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">
        <div class="bold-text main-color">
          Nom de la chirurgie
        </div>
        <div class="mt-2">
          {{ surgeryTemplate.name }}
        </div>
        <div class="mt-4 bold-text main-color">
          Description
        </div>
        <div class="multiline">
          {{ surgeryTemplate.description ? surgeryTemplate.description : '-' }}
        </div>
      </b-card>

    </b-container>

    <!-- Modal Delete -->
    <surgeryTemplate-delete-modal :selectedSurgeryTemplate="ui.selectedSurgeryTemplate" @didDeleteSurgeryTemplate="didDeleteSurgeryTemplate()"></surgeryTemplate-delete-modal>

  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/BackArrow";
import ShowActions from "../../components/ShowActions";
import SurgeryTemplateDeleteModal from "./SurgeryTemplateDeleteModal";

export default {

  name: 'SurgeryTemplateShow',

  components: {
    BackArrow,
    ShowActions,
    SurgeryTemplateDeleteModal
  },

  data() {
    return {
      surgeryTemplateId: this.$route.params.surgeryTemplateId,
      surgeryTemplate: null,
      ui: {
        selectedSurgeryTemplate: null
      }
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {

    fetchData() {
      this.fetchSurgeryTemplate()
    },

    fetchSurgeryTemplate() {
      api
        .get(`/surgeryTemplate/${this.surgeryTemplateId}`)
        .then(response => {
          this.surgeryTemplate = response.data
        })
    },

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'SurgeryTemplateEdit',
        params: {
          surgeryTemplateId: this.surgeryTemplate.id
        }
      })
    },

    clickOnDeleteBtn() {
      this.ui.selectedSurgeryTemplate = this.surgeryTemplate
      this.$bvModal.show('surgeryTemplate-delete-modal')
    },

    didDeleteSurgeryTemplate() {
      this.ui.selectedCategory = null;
      this.$router.push({
        name: 'SurgeryTemplateIndex'
      }, () => {
        this.$nextTick(() => {
          this.successToast(`SurgeryTemplate \"${this.surgeryTemplate.name}\" supprimé`)
        })
      })
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/surgeryTemplate/SurgeryTemplateShow.vue